import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

//components
import EditableTextArea from '../forms/editableTextArea.jsx';
import EditableTextField from '../forms/editableTextField.jsx';

//models
import CustomerNote from '../../../models/customerNote.jsx';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

//apis
class TimelineNote extends React.Component {
  static displayName = 'TimelineNote';

  static propTypes = {
    customerID: PropTypes.any,
    intl: intlShape.isRequired,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
  };

  state = {
    saving: false,
    activeNote:
      new CustomerNote({
        customerID: this.props.customerID,
        lastModified: moment(),
      }),
  };

  onChange = (data) => {
    let tempNote = this.state.activeNote;

    tempNote[data.key] = data.value;
    this.setState({activeNote: tempNote});
  };

  onSave = () => {
    this.setState({
      saving: true,
    });
    this.props.onSave(this.state.activeNote);
  };

  render() {
    return <table className='table table-striped table-biolab'>
      <tbody>
        <tr className='active-note'>
          <td>
            <i className={'pointer fa-2x bl ' + (this.state.activeNote.flag ? 'bl-flag-filled' : 'bl-flag')}
              onClick={this.onChange.bind(this, {key: 'flag', value: !this.state.activeNote.flag})} />
          </td>
          <td className='col-md-2 bold-date'>
            {moment().format('MMMM Do, YYYY')}
          </td>
          <td className='note-content'>
            <EditableTextField className='b' dataKey='title' value={this.state.activeNote.title} maxLength={'75'}
              onChange={this.onChange} editMode={true} validate={val => val && val.trim().length !== 0} />
            <div className='textarea-wrapper'>
              <EditableTextArea dataKey='note' value={this.state.activeNote.note} maxLength={256}
                onChange={this.onChange} editMode={true} validate={val => val && val.trim().length !== 0} />
            </div>
          </td>
          <td>
            <button className='btn btn-default' onClick={this.props.onCancel}><FormattedMessage id="general.cancel" /></button>
            <button
              className='btn btn-primary'
              onClick={this.onSave}
              disabled={
                this.state.activeNote.title.trim().length === 0 ||
                this.state.activeNote.note.trim().length === 0 ||
                this.state.saving
              }>
              {this.state.saving ? this.props.intl.formatMessage({id: 'general.saving'}) + '...' : this.props.intl.formatMessage({id: 'general.save'})}
            </button>
          </td>
        </tr>
      </tbody>
    </table>;
  }
}

export default injectIntl(TimelineNote);
